module.exports = __webpack_public_path__ + "img/tab_icon_my.1766306608134.png";